export enum RoleEnum {
  User = 'AppSupport_Bruger',
  SuperUser = 'AppSupport_SuperBruger',
  MessageReader = 'APP_DEVICE_BESKED_READER',
  MessageEditor = 'APP_DEVICE_BESKED_EDITOR',
  MessageApprover = 'APP_DEVICE_BESKED_APPROVER',
  MessageDeveloper = 'APP_DEVICE_BESKED_DEVELOPER',
}
